export default __webpack_public_path__ + "static/Muli-Regular-ef02955f64b024099d7be42e76db7ebc.woff2";